// buildDisplayRows turns the backend's FLAT row list (each row carrying
// parentNodeId and depth) into the ordered, collapsible list the table renders:
// parents immediately before their children, descendants of a collapsed node
// omitted.
//
// The response is flat rather than nested so it matches the accountability
// endpoint's shape and so collapse state stays a pure view concern.
export function buildDisplayRows(rows, collapsedIds) {
  const list = rows ?? [];
  if (list.length === 0) return [];

  const collapsed = collapsedIds ?? new Set();
  const byId = new Map(list.map((r) => [r.nodeId, r]));
  const childrenOf = new Map();
  const roots = [];

  for (const row of list) {
    const parentId = row.parentNodeId;
    // A row whose parent is absent (a concurrent hierarchy edit) is treated as a
    // root rather than dropped, so nothing silently disappears from the page.
    if (parentId == null || !byId.has(parentId)) {
      roots.push(row);
      continue;
    }
    if (!childrenOf.has(parentId)) childrenOf.set(parentId, []);
    childrenOf.get(parentId).push(row);
  }

  const out = [];
  const visit = (row) => {
    const children = childrenOf.get(row.nodeId) ?? [];
    out.push({ ...row, hasChildren: children.length > 0 });
    if (collapsed.has(row.nodeId)) return;
    for (const child of children) visit(child);
  };
  for (const root of roots) visit(root);
  return out;
}
